import { ItProjectsClient, type LinkedItemCountsDto } from "@lib/ShiOneClient";
import { ApiClientConfig } from "../../../../../auth/ApiClientConfig";

const itProjectsClient = new ItProjectsClient(
	ApiClientConfig,
	import.meta.env.API_ENDPOINT,
);

export function fetchLinkedCounts(projectId: string): Promise<LinkedItemCountsDto> {
	return itProjectsClient.getLinkedCounts(projectId);
}